import React from "react";
import { EHeaderType } from "../../../containers/Enums/Enums";
import { BoldText, NeonText } from "../../Text/Text";
import classes from "./Container.module.scss";
//@ts-ignore
import Textfit from "react-textfit";
import CustomS3Image from "../../s3Image/S3Image";

interface IHeader extends React.HTMLAttributes<HTMLElement> {
  fontSize?: string;
  rotation?: number;
  height?: string;
  text: string[];
  icon?: string;
  classHeader?: string;
  headerType?: string;
}

export const Header: React.FC<IHeader> = ({
  rotation,
  fontSize,
  children,
  height,
  text,
  style,
  icon,
  className,
  classHeader,
  headerType,
}) => {
  const CheckHeaderType = () => {
    switch (headerType) {
      case EHeaderType.Text:
        return <TextHeader fontSize={fontSize} text={text} />;
      case EHeaderType.Image:
        return <ImageHeader fontSize={fontSize} text={text} icon={icon} />;
      case EHeaderType.MultiText:
        return <MultiTextHeader fontSize={fontSize} text={text} icon={icon} />;
      case EHeaderType.MultiNeonText:
        return (
          <MultiNeonTextHeader fontSize={fontSize} text={text} icon={icon} />
        );
      default:
        return <TextHeader fontSize={fontSize} text={text} />;
    }
  };
  return (
    <div className={`${classes["container-holder"]} ${className}`}>
      {children}
      <div
        className={`${classes["page-header"]} ${classHeader}`}
        style={{ transform: `rotate(${rotation}deg)`, height, ...style }}
      >
        {CheckHeaderType()}
      </div>
    </div>
  );
};

export const ImageHeader: React.FC<IHeader> = ({ fontSize, text, icon }) => {
  return (
    <div className={`${classes["multiple-text"]}`}>
      <div className={classes["multiple-first"]}>
        <img src={icon} alt="icon" className={classes["header-icon"]} />

        <Textfit mode="single" className={classes["textFit"]} max={48} min={16}>
          {text[0]}
        </Textfit>
      </div>
      <NeonText size={fontSize}>{text[1]}</NeonText>

      <NeonText size={fontSize}>{text[2]}</NeonText>
    </div>
  );
};

export const TextHeader: React.FC<IHeader> = ({ fontSize, text }) => {
  return (
    <div className={`${classes["header-text"]}`}>
      <NeonText size={fontSize}>{text[0]} </NeonText>
    </div>
  );
};

export const MultiTextHeader: React.FC<IHeader> = ({
  fontSize,
  text,
  icon,
}) => {
  return (
    <div className={classes["multiple-text"]}>
      <div className={classes["multiple-first"]}>
        {icon && (
          <img src={icon} alt="icon" className={classes["first-image"]} />
        )}
        <BoldText size={fontSize} className={classes["multi-text-title"]}>
          {text[0]}
        </BoldText>
      </div>
      <BoldText size={fontSize} className={classes["multi-text-title"]}>
        {text[1]}
      </BoldText>
      <BoldText size={fontSize} className={classes["multi-text-title"]}>
        {text[2]}
      </BoldText>
    </div>
  );
};
export const MultiNeonTextHeader: React.FC<IHeader> = ({
  fontSize,
  text,
  icon,
}) => {
  return (
    <div className={classes["multiple-text"]}>
      <div className={classes["multiple-first"]}>
        <CustomS3Image
          s3Key={icon}
          className={classes["first-image"]}
          loader={false}
        />
        <NeonText style={{ marginTop: "5px" }} size={fontSize}>
          {text[0]}
        </NeonText>
      </div>
      <NeonText size={fontSize}>{text[1]}</NeonText>
      <NeonText size={fontSize}>{text[2]}</NeonText>
    </div>
  );
};

Header.defaultProps = {
  fontSize: "72px",
  height: "185px",
  rotation: -1.2,
};
// export default Header;
